<template>
  <div class="form-card">
    <div class="form-card__header">
      <h2 class="form-card__title">
        <i class="bi bi-clipboard"></i>
        Datos de la factura
      </h2>
    </div>
    <div class="form-card__body">
      <div class="row">
        <div class="col-sm-3 form-card__field">
          <label class="form-card__label">Proveedor <span class="text-danger">*</span></label>
          <typeahead :name="'provider'"
            :placeh="'Buscar proveedor...'"
            :clean-on="false"
            v-on:choosed="providerChoosed"
            :default="'null'"
            :externalsrc="srcClients"
            limit-chars="4"/>
          <div class="form-card__hint">Campo obligatorio</div>
        </div>

        <div class="col-sm-2 form-card__field">
          <label class="form-card__label">Fecha de emisión <span class="text-danger">*</span></label>
          <datepicker-component v-if="showChoosedate" v-on:datechoosed="dateUpdated"/>
          <div class="form-card__hint">Campo obligatorio</div>
        </div>

        <div class="col-sm-1 form-card__field" v-if="header.doctype != 'R'">
          <label class="form-card__label">Tipo <span class="text-danger">*</span></label>
          <select v-model="header.type" class="form-control">
            <option value="FC">FC</option>
            <option value="ND">ND</option>
            <option value="NC">NC</option>
          </select>
          <div class="form-card__hint">Campo obligatorio</div>
        </div>

        <div class="col-sm-1 form-card__field" v-if="header.doctype != 'R'">
          <label class="form-card__label">Letra <span class="text-danger">*</span></label>
          <select v-model="header.letter" class="form-control">
            <option value="A">A</option>
            <option value="M">M</option>
            <option value="B">B</option>
            <option value="C">C</option>
            <option value="E">E</option>
            <option value="X">X</option>
          </select>
          <div class="form-card__hint">Campo obligatorio</div>
        </div>

        <div class="col-sm-2 form-card__field">
          <label class="form-card__label">Punto de Venta</label>
          <input v-model="header.pos" type="text" class="form-control" placeholder="Ej: 0001"/>
          <div class="form-card__hint">Campo obligatorio</div>
        </div>

        <div class="col-sm-2 form-card__field">
          <label class="form-card__label">Número</label>
          <input v-model="header.number" id="number" type="text" class="form-control" placeholder="Ej: 00001234"/>
          <div class="form-card__hint">Campo obligatorio</div>
        </div>

        <div class="col-sm-1 form-card__field" v-if="header.doctype != 'R'">
          <label class="form-card__label">Productos</label>
          <div>
            <input class="prod" v-model="header.loadproducts" type="checkbox"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import typeahead from '../../../global/Typeahead.vue';
import datepickerComponent from '../../../global/Datepicker-component.vue';

export default {
  props: ['company_typetax', 'showChoosedate', 'config'],
  data: function() {
    return {
      header: { 
        provider_id: null, 
        number: null, 
        type: 'FC', 
        letter: null, 
        receipt_date: null, 
        pos: null, 
        loadproducts:  null, 
        doctype: null,
      },
      srcClients: '/api/providers/getProviders'
    }
  },
  mounted: function () {
    this.$emit('headerchanged', this.header);
  },
  watch: {
    'header': { // Esto envia los datos de header cada vez que cambian al receipt donde seran adjuntados al payload
      handler: function () {
        this.$emit('headerchanged', this.header);
      }, deep: true,
    },
    config:function(){
      this.header.doctype = this.config.doctype ;
      this.header.loadproducts = this.config.loadproducts;
    }
  },
  methods: {
    dateUpdated: function (date) {
      var app = this;
      app.header.receipt_date = date;
    },
    providerChoosed(data) {
      this.header.provider_id=data.id;
    }
   },
   components:{
    typeahead,
    datepickerComponent
  }
}
</script>

<style lang="scss">
  .prod {
    width: 28px;
    height: 28px;
  }

  // Neutralizar offsets globales para alinear typeahead y datepicker
  // con el resto de los inputs dentro del form-card.
  .form-card {
    .typeahead__container {
      margin-top: 0;
    }

    .form-group {
      margin-bottom: 0;
    }

    // Ícono interno del typeahead — el global lo posiciona con top:22px
    // pensado para un input sin label; lo bajamos a la altura del input.
    .typeahead__container > i {
      top: 50%;
      transform: translateY(-50%);
    }
  }
</style>
